module.exports = __webpack_public_path__ + "c08f2183de73f5ef68dbbb57e48a34ae.png";